import React from 'react';
import FranchiseCompanyDashboard from '../components/FranchiseCompanyDashboard';

export default function KPK() {
  return (
    <FranchiseCompanyDashboard
      icon="🔑"
      title="КПК Россия"
      subtitle="Ключ под ключ, отдельная франшизная сеть, будет подключена к МойСклад своим токеном"
      color="#00a7dc"
      networkSize="70+"
      moneyTarget="ООО БОБ / Tinkoff"
      tokenEnvName="KPK_MOYSKLAD_TOKEN"
      network="kpk"
    />
  );
}
